import { PageController } from '@client/components/_core/layout/PageController';
import { AiLodgementPage } from '@client/components/lodgement/ai-lodgement/AiLodgementPage';
import { aiLodgementSearchSchema } from '@client/components/lodgement/ai-lodgement/ai-lodgement-search';
import { useOrgId } from '@client/hooks/business/org/useOrgId';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { FileStack } from 'lucide-react';

/**
 * Lodge a claim from documents (CUR-1744): staff drop a claim email or files, the server unpacks and
 * reads them, and AI prepares the staff lodgement draft. Opened from the claims list New claim menu.
 * The server gates every call on the products-v2 flag as well.
 */
export const Route = createFileRoute('/console/$orgId/claims/lodge-from-documents')({
    staticData: {
        metadata: { title: 'Lodge from documents' },
        breadcrumb: { title: 'Lodge from documents' },
        ui: {
            icon: FileStack,
            title: 'Lodge from documents',
            subtitle: 'Upload a claim email or documents. AI reads them and suggests the product for you to confirm.',
        },
        modules: ['claim'],
        permissions: ['claim:create'],
        // Literal (AI_CLAIM_LODGEMENT_FLAG_KEY): the route registry generator reads it statically.
        featureFlag: 'enable-ai-claim-lodgement',
    },
    validateSearch: aiLodgementSearchSchema,
    component: RouteComponent,
});

function RouteComponent() {
    const orgId = useOrgId();
    const navigate = useNavigate();
    const { runId } = Route.useSearch();
    return (
        <PageController route={Route}>
            <AiLodgementPage
                runId={runId}
                onRunIdChange={(next) =>
                    navigate({
                        to: '/console/$orgId/claims/lodge-from-documents',
                        params: { orgId },
                        search: next === undefined ? {} : { runId: next },
                        replace: true,
                    })
                }
                onLeave={() => navigate({ to: '/console/$orgId/claims', params: { orgId } })}
                onOpenClaim={(claimId) =>
                    navigate({ to: '/console/$orgId/claims/details/$id', params: { orgId, id: claimId } })
                }
            />
        </PageController>
    );
}
